import React from 'react'
import { H3 } from '../Heading/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'

/**
 * The membership promo component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onJoinButtonClick - The join gaia button event handler
 * @returns {JSX.Element} The membership promo component
 */

function GaiaPlusMembership (props) {
  const {
    staticText,
    onJoinButtonClick,
  } = props

  return (
    <div className="gaia-plus-page__membership">
      <div className="gaia-plus-page__membership-container">
        <H3>{staticText.get('membershipTitle')}</H3>
        <p className="gaia-plus-page__membership-text">
          {staticText.get('membershipText')}
        </p>
        <div className="gaia-plus-page__membership-poster"></div>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          className="gaia-plus-page__membership-button"
          onClick={onJoinButtonClick}
        >
          {staticText.get('joinGaiaPlusNow')}
        </Button>
      </div>
    </div>
  )
}

export default GaiaPlusMembership
